import { finalize } from 'rxjs/operators';
import { getHomeUrlByRole } from '@core/enums/entry-url.enum';
import { ErrorModel } from '@core/api';
import { SmsTimerService, UnexpectedErrorMessageService } from '@core/services';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { BaseMode } from './base-mode';
import { RequestIdService } from '../../../services/request-id.service';
import { AuthService } from '../../../services/auth.service';
import { UserService } from '../../../services/user.service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { environment } from '../../../../../../environments/environment';
import { UnexpectedErrorComponent } from '@ui/ui-errors';

@Injectable({
  providedIn: 'root'
})
export class AuthMode extends BaseMode {
  public title: string = this.i18n('Авторизация');
  public startUrl: string = environment.loginUrl;

  private returnUrl: string = null;

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private requestIdService: RequestIdService,
    private smsTimerService: SmsTimerService,
    private snackBar: UnexpectedErrorMessageService,
    private router: Router,
    private i18n: I18n
  ) {
    super();
  }

  submit (value) {
    this.loadingSubject.next(true);

    this.authService.login2faVerify(value)
      .pipe(finalize(() => this.loadingSubject.next(false)))
      .subscribe(data => {
          const role = this.userService.currentUserValue && this.userService.currentUserValue.role;
          this.returnUrl = getHomeUrlByRole(role);

          this.router.navigateByUrl(this.returnUrl).then(()=>{
            this.smsTimerService.offSmsTimer();
            this.requestIdService.reset();
          }).catch((e) => {
            this.requestIdService.reset();

            console.error(e);

            this.snackBar.openFromComponent(UnexpectedErrorComponent);

            this.router.navigate([this.startUrl]).then(() => {
              this.smsTimerService.offSmsTimer();
            });
          });
        },
        (err: ErrorModel) => {
          this.errorSubject.next(err);
        });
  }

  repeat () {
    this.repeatLoadingSubject.next(true);

    this.authService.login(this.requestIdService.value.phoneNumber)
      .pipe(finalize(() => this.repeatLoadingSubject.next(false)))
      .subscribe(data => {
        this.smsTimerService.onSmsTimer(this.requestIdService.value.time);
      });
  }
}
